import { render } from "./DescuentoGeneralModal.vue?vue&type=template&id=0d3334c8&scoped=true"
import script from "./DescuentoGeneralModal.vue?vue&type=script&lang=js"
export * from "./DescuentoGeneralModal.vue?vue&type=script&lang=js"

import "./DescuentoGeneralModal.vue?vue&type=style&index=0&id=0d3334c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3334c8"]])

export default __exports__